import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Logo from "assets/images/edushala.png";

function Tables() {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={6} display="flex" justifyContent="center" alignItems="center">
        <Card
          sx={{
            p: 5,
            textAlign: "center",
            width: "100%",
            boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
            borderRadius: "20px",
            background: "linear-gradient(135deg, #f5f9ff, #ffffff)",
          }}
        >
          {/* Logo */}
          <ArgonBox display="flex" justifyContent="center" mb={3}>
            <img src={Logo} alt="Edushala Logo" style={{ width: "140px" }} />
          </ArgonBox>

          {/* Heading */}
          <ArgonTypography variant="h3" fontWeight="bold" color="primary" gutterBottom>
            Welcome to <span style={{ color: "#2196f3" }}>Edushala</span> Dashboard
          </ArgonTypography>

          <ArgonTypography variant="body1" color="text" mb={4}>
            Manage your data, track progress, and explore features with ease 🚀
          </ArgonTypography>
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
